export default __webpack_public_path__ + "static/media/contishop-familyfriends-home-bg.06c494de.jpg";